import React from 'react';
import { Box } from '@mui/material';
import Loader from '../Loader';
import pallet from '../../layouts/pallet';

interface OverlayLoaderProps {
  show: boolean;
}

const OverlayLoader: React.FC<OverlayLoaderProps> = ({ show }) => {
  if (!show) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: pallet.overlayLight,
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(0.5px)'
      }}
    >
      <Loader show={show} />
    </Box>
  );
};

export default OverlayLoader;
